import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { testUrl } from "../BaseData";
import "./DormitoryApplication.css";

const DormitoryApplication = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        fullName: "",
        educationLevel: "",
        educationForm: "",
        course: "",
        direction: "",
        address: "",
        jshshr: "",
    });

    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [applicationNumber, setApplicationNumber] = useState(null);
    const [applicationId, setApplicationId] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validateForm = () => {
        const { fullName, educationLevel, educationForm, course, direction, address, jshshr } = formData;
        if (!fullName || !educationLevel || !educationForm || !course || !direction || !address || !jshshr) {
            alert("Iltimos, barcha maydonlarni to'ldiring!");
            return false;
        }
        if (jshshr.length !== 14) {
            alert("JSHSHR 14 xonali bo'lishi kerak!");
            return false;
        }
        return true;
    };

    const triggerDownload = (blobData, appNum) => {
        const blob = new Blob([blobData], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Shartnoma_${appNum}_${formData.fullName}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    const downloadPdf = async (appNum) => {
        try {
            let response;
            if (applicationId) {
                response = await axios.get(
                    `${testUrl}/api/dormitory-applications/${applicationId}/download-pdf/`,
                    { responseType: "blob" }
                );
            } else {
                response = await axios.post(
                    `${testUrl}/api/dormitory-applications/generate-pdf/`,
                    formData,
                    { responseType: "blob" }
                );
            }
            const returnedNum = response.headers["x-application-number"] || appNum;
            triggerDownload(response.data, returnedNum);
        } catch (err) {
            console.error("PDF yuklab olishda xatolik:", err);
            alert("PDF yuklab olishda xatolik yuz berdi.");
        }
    };

    const handleSubmitAndDownload = async () => {
        if (!validateForm()) return;

        setSubmitting(true);
        try {
            const response = await axios.post(
                `${testUrl}/api/dormitory-applications/generate-pdf/`,
                formData,
                { responseType: "blob" }
            );

            const appNum = response.headers["x-application-number"] || "—";
            const appId = response.headers["x-application-id"] || null;
            setApplicationNumber(appNum);
            setApplicationId(appId);
            setSubmitted(true);
            triggerDownload(response.data, appNum);

        } catch (err) {
            console.error("Ariza yuborishda xatolik:", err);
            if (err.response?.data) {
                try {
                    const text = await err.response.data.text();
                    const json = JSON.parse(text);
                    if (json.application_number) {
                        setApplicationNumber(json.application_number);
                        if (json.id) setApplicationId(json.id);
                        setSubmitted(true);
                        alert(`Arizangiz saqlandi (#${json.application_number}), lekin PDF yaratishda xatolik yuz berdi.`);
                        return;
                    }
                } catch (_) { }
            }
            alert("Ariza yuborishda xatolik yuz berdi. Iltimos qaytadan urinib ko'ring.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="application-container">
            <div className="form-card">
                <h2>{t("Ariza topshirish")}</h2>
                <p className="form-subtitle">Iltimos, barcha maydonlarni to'ldiring</p>

                <div className="form-grid">
                    <div className="input-group">
                        <label>{t("f_i_sh") || "F.I.SH (To'liq ism)"}</label>
                        <input
                            type="text"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                            placeholder="Eshmatov Toshmat"
                            disabled={submitted}
                        />
                    </div>

                    <div className="input-group">
                        <label>{t("talim_bosqichi") || "Ta'lim bosqichi"}</label>
                        <select name="educationLevel" value={formData.educationLevel} onChange={handleChange} disabled={submitted}>
                            <option value="">{t("Tanlang") || "Tanlang"}</option>
                            <option value="Bakalavr">{t("Bakalavr") || "Bakalavr"}</option>
                            <option value="Magistratura">{t("Magistratura") || "Magistratura"}</option>
                        </select>
                    </div>

                    <div className="input-group">
                        <label>{t("talim_shakli_label") || "Ta'lim shakli"}</label>
                        <select name="educationForm" value={formData.educationForm} onChange={handleChange} disabled={submitted}>
                            <option value="">{t("Tanlang") || "Tanlang"}</option>
                            <option value="Kunduzgi">{t("Kunduzgi") || "Kunduzgi"}</option>
                            <option value="Kechki">{t("Kechki") || "Kechki"}</option>
                            <option value="Sirtqi">{t("Sirtqi") || "Sirtqi"}</option>
                        </select>
                    </div>

                    <div className="input-group">
                        <label>{t("oquv_kursi") || "O'quv kursi"}</label>
                        <input
                            type="text"
                            name="course"
                            value={formData.course}
                            onChange={handleChange}
                            placeholder="1-kurs"
                            disabled={submitted}
                        />
                    </div>

                    <div className="input-group full-width">
                        <label>{t("talim_yonalishi_label") || "Ta'lim yo'nalishi"}</label>
                        <input
                            type="text"
                            name="direction"
                            value={formData.direction}
                            onChange={handleChange}
                            placeholder="Kompyuter injiniringi"
                            disabled={submitted}
                        />
                    </div>

                    <div className="input-group full-width">
                        <label>{t("manzil") || "Manzil"}</label>
                        <input
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="Viloyat, shahar, tuman, ko'cha, uy"
                            disabled={submitted}
                        />
                    </div>

                    <div className="input-group full-width">
                        <label>{t("jshshr") || "JSHSHR (Personal identifikatsiya raqami)"}</label>
                        <input
                            type="text"
                            name="jshshr"
                            value={formData.jshshr}
                            onChange={handleChange}
                            placeholder="14 xonali raqam"
                            maxLength={14}
                            disabled={submitted}
                        />
                    </div>
                </div>

                <div className="button-group">
                    <button className="back-btn" onClick={() => navigate(-1)}>
                        Orqaga qaytish
                    </button>
                    {!submitted ? (
                        <button
                            className="download-btn"
                            onClick={handleSubmitAndDownload}
                            disabled={submitting}
                        >
                            {submitting ? "Yuborilmoqda..." : "Ariza topshirish"}
                        </button>
                    ) : (
                        <div className="success-footer">
                            <p>✅ Arizangiz muvaffaqiyatli qabul qilindi!</p>
                            <button className="download-btn secondary" onClick={() => downloadPdf(applicationNumber)}>
                                Shartnomani yuklab olish (#{applicationNumber})
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DormitoryApplication;
